/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var TextBoxController = require("./TextBoxController");

ko.bindingHandlers.pliTextBox = {
    requireController: TextBoxController.prototype._requireController,

    init: TextBoxController.prototype._koInit,
    update: TextBoxController.prototype._koUpdate
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols/pliTextBoxBinding.js
// module id = 16
// module chunks = 49